const headerVariants = {
  hidden: {
    y: -55,
    opacity: 0
  },
  visible: {
    y: 0,
    opacity: 1
  }
};

export default headerVariants;

